/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const watchStatItemSchema = z.object({
  label: z.string(),
  value: z.number().int(),
});

const watchStatGroupSchema = z.object({
  title: z.string(),
  items: z.array(watchStatItemSchema),
});

export const getWatchReviewStatsResponseDataSchema = z.object({
  groups: z.array(watchStatGroupSchema),
});

export type IGetWatchReviewStatsResponseData = z.infer<
  typeof getWatchReviewStatsResponseDataSchema
>;

export const getWatchReviewStatsResponseSchema = createApiResponseSchema(
  getWatchReviewStatsResponseDataSchema,
) as z.ZodSchema<IAPI<IGetWatchReviewStatsResponseData>>;

export type IGetWatchReviewStatsResponse = IAPI<IGetWatchReviewStatsResponseData>;
